/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const securityEventPageItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const securityEventPageItemsItemOccurredAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const securityEventPagePageMax = 9007199254740991

export const securityEventPagePageSizeMax = 100

export const securityEventPageTotalMin = 0
export const securityEventPageTotalMax = 9007199254740991

export const SecurityEventPage = zod.object({
  items: zod.array(
    zod.object({
      decision: zod.enum([
        'flag',
        'would_challenge',
        'challenge',
        'challenge_passed',
        'challenge_failed',
        'block',
        'rate_limited',
        'cap_reached',
        'clinic_ceiling',
        'recaptcha_unavailable',
      ]),
      id: zod.uuid().regex(securityEventPageItemsItemIdRegExp),
      mode: zod.enum(['monitor', 'enforce']),
      occurredAt: zod.iso.datetime({ offset: true }).regex(securityEventPageItemsItemOccurredAtRegExp),
      requestId: zod.string(),
      route: zod.string(),
      rules: zod.array(zod.string()),
      signals: zod.record(zod.string(), zod.unknown()),
      source: zod.string().nullable(),
    }),
  ),
  page: zod.int().min(1).max(securityEventPagePageMax),
  pageSize: zod.int().min(1).max(securityEventPagePageSizeMax),
  total: zod.int().min(securityEventPageTotalMin).max(securityEventPageTotalMax),
})

export type SecurityEventPage = zod.input<typeof SecurityEventPage>
export type SecurityEventPageOutput = zod.output<typeof SecurityEventPage>
